import { types } from 'mobx-state-tree';
import { TopBetsBaseStore } from './topBetsBase';
import { TopOfferType } from '../api/topOfferType';

export const TopBetsCustomCategory = types
    .compose(
        TopBetsBaseStore,
        // use typeAdditionalData to specify category id
        types.model({})
    )
    .views(_self => ({
        /**
         * Overrides TopBetsBaseStore view
         */
        get type(): TopOfferType {
            return TopOfferType.CustomCategory;
        },

        /**
         * Overrides TopBetsBaseStore view
         */
        get showDayOfDateInEvents(): boolean {
            return __IsMTS__;
        },

        /**
         * Overrides TopBetsBaseStore view
         */
        get useRemainingTimeInEvents(): boolean {
            return !__IsMTS__;
        }
    }))
    /*.actions(self => {
        return {}
    })*/;
